module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABFUlEQVQ4je3SvytFcRzG8de9fuUudzL5FyysiouQImEzWNRR/h6pe0abGOnKYJNMBhZltSmyGCT66nPrkuO6GSye6XM+z/O8+57zPf71a5Xq9Xo7RglbKGMTr61mlmUfwt1tYF3YTr147sEGXooK3wETbAereI7dOvqxVgQtF8B6sRuwJyxjMea024vMj4ApuI+VAMzjAI2Y024pMn3tgJUoLuAR0zhp8dM8FV7KNPI8rxQBq3GSSTxgBqdfvMFZePeYwGGe59XPwLQ4jsAdxnBe8H2FNx7ZWuo2oek/HMARRnCLOVx+A2vVUHQHcYHZcpysCat1AEu6ik7qDidWOW7qGqO46QD2rizLbqJ7/dWt/+uvhTfQHz8NiHtK9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/icon/family_menu_up.png
// module id = vvtZ
// module chunks = 1